export const APP_CONFIG_SWR_KEY = "app-config";

const USER_CONTEXT_PREFIX = "/users/";

function encodeUserID(userID: string): string {
  return encodeURIComponent(userID);
}

function getUserContextPrefix(userID: string): string {
  return `${USER_CONTEXT_PREFIX}${encodeUserID(userID)}/`;
}

export function getCompaniesKey(userID: string): string {
  return `${getUserContextPrefix(userID)}companies`;
}

export function getCompanyWorkspacesKey(userID: string, companyID: number): string {
  return `${getCompaniesKey(userID)}/${companyID}/workspaces`;
}

export function getWorkspaceContextKey(userID: string, workspaceID: number): string {
  return `${getUserContextPrefix(userID)}workspaces/${workspaceID}/context`;
}

export function isCompanyWorkspaceCacheKey(key: unknown, userID?: string | null): boolean {
  if (typeof key !== "string") {
    return false;
  }

  if (userID == null) {
    return key.startsWith(USER_CONTEXT_PREFIX);
  }

  const userPrefix = getUserContextPrefix(userID);
  return (
    key === getCompaniesKey(userID) ||
    key.startsWith(`${userPrefix}companies/`) ||
    key.startsWith(`${userPrefix}workspaces/`)
  );
}
